export const ASSIGN_FUNCTION = {
    id: 'value',
    title: 'SHARED.ASSIGN'
};
